import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { checkInboundTaskItemAction } from 'redux-stores/actions';

import { ItemDialogConfigEnum } from '../enums';
import { IItemDialogData } from '../interfaces';

export const ItemDialogConfig: Record<ItemDialogConfigEnum, IItemDialogData> = {
  [ItemDialogConfigEnum.APPROVE]: {
    title: 'Approve',
    content: (skuCode: string): string => {
      return `Are you sure to approve SKU ${skuCode}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      inboundTaskNumber: string,
      invoiceNumber: string,
      skuCode: string,
      foc: boolean,
    ): void => {
      dispatch(
        checkInboundTaskItemAction({
          inbound_task_number: inboundTaskNumber,
          invoice_number: invoiceNumber,
          sku_code: skuCode,
          foc,
          approved: true,
        }),
      );
    },
  },
  [ItemDialogConfigEnum.REJECT]: {
    title: 'Reject',
    content: (skuCode: string): string => {
      return `Are you sure to reject SKU ${skuCode}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      inboundTaskNumber: string,
      invoiceNumber: string,
      skuCode: string,
      foc: boolean,
    ): void => {
      dispatch(
        checkInboundTaskItemAction({
          inbound_task_number: inboundTaskNumber,
          invoice_number: invoiceNumber,
          sku_code: skuCode,
          foc,
          approved: false,
        }),
      );
    },
  },
};
